import { DefaultLocales, LocaleName } from "@/app/i18n/settings";

// Expects price amount in cents
export function formatPrice(lng: LocaleName, amount: number, currency: string) {
  const euroFormatter = new Intl.NumberFormat(DefaultLocales[lng].baseName, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  });
  return euroFormatter.format(amount / 100);
}
